import React, { FC, useMemo } from 'react';
import { FriendTablesSeatsPreview } from '@/services/friends/friendsServicesTypes';
import MultipleTablesPreview from '@/pages/friends/components/MultipleTablesPreview';
import TableStatus from '@/components/TableStatus/TableStatus';

interface FriendTablesStatusProps {
  tables: FriendTablesSeatsPreview[];
  onClickShowDetails: () => void;
}
const FriendTablesStatus: FC<FriendTablesStatusProps> = ({ tables, onClickShowDetails }) => {
  if (tables.length === 0) {
    return (
      <span className="flex w-full justify-center text-sm text-white text-opacity-50 md:block md:pl-2">Offline</span>
    );
  }
  const activePlayerCount = useMemo(
    () => tables[0].table.seats.reduce((acc, seat) => acc + (seat?.active ? 1 : 0), 0),
    [tables[0].table.seats],
  );

  if (tables.length === 1) {
    return (
      <TableStatus
        padding={false}
        playerCount={tables[0].table.seats.length}
        activePlayerCount={activePlayerCount}
        maxPlayers={tables[0].table.maxPlayers}
        tableName={tables[0].table.name}
        tableGame={tables[0].table.game}
      />
    );
  }

  return <MultipleTablesPreview tablesCount={tables.length} onClickSeeDetails={onClickShowDetails} />;
};

export default FriendTablesStatus;
